import {MessageCodes} from "../MessageCodes";
import {useAppContext} from "../../../context/AppContext";
import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultBody from "../../../components/table/ResultBody";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";
import HecRasHelper from "../../../helpers/HecRasHelper";

const ROWS = [
    {label: 'Water surface calculation tol. (.0001 - .1 ft)', field: 'stdStepTol'},
    {label: 'Critical depth calculation tol. (.0001 - .1 ft)', field: 'criticalTol'},
    {label: 'Maximum number of iterations (3 - 40)', field: 'numOfStdStepTrials'},
    {label: 'Maximum difference tolerance (.1 - 1.0 ft)', field: 'maxErrorTol'},
    {label: 'Flow tolerance factor (.0001 - .05)', field: 'flowTolRatio'},
    {label: 'Maximum iteration in Split flow (3 - 100)', field: 'splitFlowNTrial'},
    {label: 'Flow tolerance factor in weir split flow (.0001 - .05)', field: 'splitFlowRatio'},
    {label: 'Max difference in junction split flow (.001 - .1 ft)', field: 'splitFlowTol'},
]

export function OV4({message_key}) {
    const {getSelectedHistory} = useAppContext()
    const {user} = useUser()

    const tolerances = getSelectedHistory()?.calculation_tolerances || {}
    const userDefault = user.settings.calculation_tolerances

    return (
        <ResultView error_id={MessageCodes.Internal.OV04.error_id} message_key={message_key}>
            <ResultText>
                HEC-RAS calculation tolerances of the plan are tabulated below. Values different than the User Default are highlighted in red.
            </ResultText>
            <EmptyLine/>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell colSpan={3}>HEC-RAS Calculation Tolerances</ResultHeaderCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(40)}}>Calculation</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>User Default</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Plan Value</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {ROWS.map((r, idx) => (
                        <ResultRow key={idx}>
                            <ResultHeaderCell style={{textAlign: 'left'}}>{r.label}</ResultHeaderCell>
                            <ResultBodyCell style={{textAlign: 'right'}}>{userDefault[r.field]}</ResultBodyCell>
                            <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(userDefault[r.field], tolerances[r.field])}</ResultBodyCell>
                        </ResultRow>
                    ))}
                </ResultBody>
            </ResultTable>
        </ResultView>
    )
}
